<template>
  <div class="wrapper">
    <div class="grid">
      <h1>Network issues</h1>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NetworkIssue",
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>

</style>
